<div
  *ngIf="count"
  class="flex"
  [class.space-x-1]="isHorizontal"
  [class.space-y-1]="isVertical"
  [class.flex-col]="isVertical"
  [class.dark-bg]="dark"
  data-cy="dots-container"
>
  <button
    *ngFor="let _ of [].constructor(count); let i = index"
    [disabled]="isDisabled"
    class="dot rounded-full w-2 h-2 border"
    [class.selected]="isSelected(i)"
    [class.cursor-default]="isDisabled"
    (click)="handleClick($event, i)"
    [attr.aria-label]="'dots-dot-' + i"
    data-cy="dots-dot"
  ></button>
</div>
